import { Swiper, SwiperSlide } from "swiper/react";
import Explore1 from "../../assets/images/explore1.png"
import Explore2 from "../../assets/images/explore2.png"
import "swiper/swiper-bundle.css";
import { useState } from "react";
// import image from "../../assets/images/footerImg/aboutHero.svg";
import { ERCButton } from "components/button";
import { useNavigate } from "react-router-dom";

const SliderWithProgress = () => {
  const navigate = useNavigate();
  const [isDragging, setIsDragging] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    { text: "Slide 1", image: Explore1 },
    { text: "Slide 2", image: Explore2 },
    { text: "Slide 3", image: Explore2 },
  ];

  return (
    <div className="flex w-full  py-12 ">
      {/* Progress bar (chain-like with circles) */}
      <div className="w-8  flex flex-col gap-6 items-center justify-center space-y-4">
        {slides.map((_, index) => (
        <div className="relative">
            <div
            key={index}
            className={`w-4 h-4 z-[999] rounded-full border-2 transition-all duration-300 ${
              index === activeIndex
                ? "bg-primary border-primary z-[9999]"
                : "bg-gray-300 border-gray-300"
            }`}
          ></div>
          <span className="absolute w-[2px]  h-24 left-2  top-[-35px] bg-gray-300"> 

          </span>
        </div>
        ))}
      </div>

      {/* Slider container */}
      <div className="flex-grow relative overflow-hidden w-full">
        <Swiper
        onSlideChange={(swiper) => {
            setActiveIndex(swiper.activeIndex);
            setIsDragging(false); // When the slide change is complete
          }}
          onTouchStart={() => setIsDragging(true)} // Detect dragging
          onTouchEnd={() => setIsDragging(false)} // Stop dragging
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides={true}
          grabCursor={true}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="flex gap-12  items-center w-full">
                {/* Main Content Area */}
                <div className="md:w-[70%]  flex items-center gap-6">
                  {/* Text content */}
                  <div className="p-4 md:w-[50%] flex flex-col gap-6">
                    <div className="flex gap-2">
                      <h2 className="text-[18px] font-ManropeSemibold leading-[20px] text-primary">
                        ONLINE EXHIBIT
                      </h2>
                    </div>
                    <h1 className="md:text-[40px] text-[24px] md:leading-[48px]  font-ManropeBold">
                      The Cathedral Church of Christ Marina
                    </h1>
                    <p className="text-[#525252] md:text-[16px] md:leading-[24px]">
                    Lagos offers remarkable sites that showcase its unique charm and history. Visit the stunning Cathedral Church of Christ at CMS, an architectural gem and symbol of Lagos’s rich heritage. Nature lovers will enjoy the Lekki Conservation Centre, with its lush landscape and famous canopy walkway. For history and relaxation, Freedom Park in Lagos Island combines heritage with serene green spaces, making Lagos a diverse city worth exploring.
                    </p>
                    <div>
                      <ERCButton
                        weight={"700"}
                        g={"8px"}
                        size="16px"
                        p={"16px 24px"}
                        color="#00296B"
                        bgcolor="#FFD600"
                        lHeight="24px"
                        width="184px"
                        showArrow
                        onClick={() => {
                          window.scrollTo(0, 0);
                          navigate("/");
                        }}
                      >
                        Explore
                      </ERCButton>
                    </div>
                  </div>
                  {/* Main image */}
                  <div className="relative w-[50%]  ">
                    <img
                      src={slide.image}
                      alt={`Slide ${index + 1}`}
                      className={`w-full lg:h-[529px] transition-transform duration-500 ease-in-out ${
                        index === activeIndex ? "scale-100" : "scale-75"
                      }`}
                    />
                  </div>
                </div>
                {/* Preview of the next image */}
                {/* {index < slides.length - 1 && (
                  <div className="w-[30%] h-full flex  justify-end items-center">
                    <img
                      src={slides[index + 1].image}
                      alt={`Preview Slide ${index + 2}`}
                      className="w-full md:h-[375px] rounded-lg object-cover "
                    />
                  </div>
                )} */}
                {/* Preview of the next images */}
                {index === activeIndex && !isDragging && (
                  <div className="w-[30%] h-full  flex items-center gap-6 space-y-4">
                    {slides
                      .slice(index + 1)
                      .map((remainingSlide, remainingIndex) => (
                        <img
                          key={remainingIndex}
                          src={remainingSlide.image}
                          alt={`Preview Slide ${index + 2 + remainingIndex}`}
                          className="w-full md:h-[360px] rounded-lg object-cover "
                        />
                      ))}
                  </div>
                )}

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SliderWithProgress;
